import { AutomationRuleEnums } from "models/enums";
import { SelectionItem } from "models/utilTypes/selectionTypes";
import { useMemo } from "react";
import { AutomationRuleTypeHelper, EnumHelper } from "utils/helpers";

function useAvailableRuleTypesList() {
  const availableRuleTypes: SelectionItem[] = useMemo(() => {
    return EnumHelper.getNumericItemValues(AutomationRuleEnums.AutomationRuleType)
      .filter((e) => e !== AutomationRuleEnums.AutomationRuleType.Unknown)
      .map((type) => ({
        id: type,
        value: AutomationRuleTypeHelper.getTranslatedRuleTypeText(type),
      }));
  }, []);

  return {
    availableRuleTypes,
  };
}

export default useAvailableRuleTypesList;
